import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {NavigationEnd, Router,} from '@angular/router';
import {filter} from 'rxjs';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../services/billets.service';
import {Meta, Title} from '@angular/platform-browser';
import {cookiesService} from '../../services/cookies.service';
import {SettingsComponent} from '../../components/settings/settings.component';
import {SettingsService} from '../../services/settings.service';

@Component({
  selector: 'marathon-page',
  templateUrl: './marathon.component.html',
  imports: [
    NgForOf,
    NgIf,
    SettingsComponent
  ],
  styleUrl: './marathon.component.less'
})
export class MarathonPageComponent {
  open_explanation = false
  active_billet = 0
  @ViewChild('scrollContainerBillets')
  scrollContainerBillets!: ElementRef<HTMLDivElement>;

  @ViewChildren('billet')
  billets!: QueryList<ElementRef<HTMLElement>>;

  scroll_billets: any = {
    all_billets: false,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    moved: false,
    element: null as HTMLElement | null,
    isEnd: false
  }


  constructor(public SettingsService: SettingsService, private cookies: cookiesService, @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private title: Title, private meta: Meta, public BilletsService: BilletsService, private cd: ChangeDetectorRef) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.SettingsService.set_open_settings(false)
          this.active_billet = 0
          if (this.BilletsService.billets_question[this.active_billet]?.marathon?.select) {
            this.open_explanation = true
          }
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });

        }
      });
  }

  ngAfterViewInit() {
    this.scrollContainerBillets.nativeElement.scrollLeft = 0
  }

  ngOnInit(): void {
    this.title.setTitle('ПДД Марафон 2026 🚘 — все билеты ГИБДД подряд без ошибок | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'Пройдите ПДД Марафон 2026 онлайн: все экзаменационные вопросы ГИБДД подряд без повторов. Проверка знаний, статистика ошибок, актуальные билеты и подготовка к экзамену.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'пдд  марафон, марафон пдд 2026, экзамен пдд онлайн, билеты пдд, все билеты пдд, 800 вопросов пдд, подготовка к экзамену гибдд, теория пдд, экзамен гибдд, пдд без ошибок'
    });

    this.BilletsService.delete_statistics$
      .subscribe(value => {
        this.open_explanation = false
        this.cd.detectChanges();
      });

    this.SettingsService.showResults_os$
      .subscribe(value => {
        this.cd.detectChanges();
      });
  }

  onMouseDown(event: MouseEvent, element: HTMLElement) {
    this.scroll_billets.moved = false;
    if (this.scroll_billets.all_billets == false) {
      this.scroll_billets.isDragging = true;
      this.scroll_billets.element = element;

      this.scroll_billets.startX = event.pageX;
      this.scroll_billets.scrollLeft = element.scrollLeft;
    }

  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.scroll_billets.isDragging || !this.scroll_billets.element) {
      return;
    }

    const dx = event.clientX - this.scroll_billets.startX;
    if (dx > 15 || dx < -15) {
      this.scroll_billets.moved = true;
    }
    if (this.scroll_billets.moved == true) {

      this.scroll_billets.element.scrollLeft -= dx;

      this.scroll_billets.startX = event.clientX;
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.scroll_billets.isDragging = false;
    this.scroll_billets.element = null;
  }


  openBillet(index: number) {
    if (this.scroll_billets.moved == false) {
      this.open_explanation = true
      this.active_billet = index

      if (!this.BilletsService.billets_question[this.active_billet]?.marathon?.select) {
        this.open_explanation = false
      }

    }
    this.scrollBileetsList()
  }
  scrollBileetsList() {
    const element = this.billets.get(this.active_billet);
    if (this.scroll_billets.all_billets == false) {
      element?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',   // start | center | end | nearest
        block: 'nearest'
      });
    }
  }
  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    this.scroll_billets.scrollLeft = element.scrollLeft;

    this.scroll_billets.isEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 50;

  }

  scrollLeft(element: HTMLElement) {
    element.scrollBy({
      left: -(element.clientWidth / 2),
      behavior: 'smooth'
    });
  }

  scrollRight(element: HTMLElement) {
    element.scrollBy({
      left: (element.clientWidth / 2),
      behavior: 'smooth'
    });
  }

  vueAllBillets() {
    this.scroll_billets.all_billets = !this.scroll_billets.all_billets
    if (this.scroll_billets.all_billets == false) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // или убери behavior для мгновенного скролла
      });
    }
    this.cd.detectChanges();
    this.scrollBileetsList()
  }

  chekAnswer(question_index: number, answer_index: number) {


    const question = this.BilletsService.billets_question[question_index];

    if (!question?.marathon?.select) {

      let answer = this.BilletsService.billets_question[question_index].answers[answer_index].correct
      let add_q = true
      for (let i = 0; i < this.BilletsService.my_answer_marathon.length; i++) {
        if (this.BilletsService.my_answer_marathon[i].index_question == question_index) {
          this.BilletsService.my_answer_marathon[i].index_question = question_index
          this.BilletsService.my_answer_marathon[i].index_answer = answer_index
          add_q = false
          break;
        }
      }

      if (add_q) {
        this.BilletsService.my_answer_marathon.push({
          index_question: question_index,
          index_answer: answer_index
        })

        this.BilletsService.billets_question[question_index].marathon = {select: true, status: answer}
      }

      for (let i = 0; i < this.BilletsService.billets_question[question_index].answers.length; i++) {
        if (i == answer_index) {
          this.BilletsService.billets_question[question_index].answers[i].marathon_select = true
        } else {
          this.BilletsService.billets_question[question_index].answers[i].marathon_select = false
        }
      }
      localStorage.setItem(
        "pdd_marathon",
        JSON.stringify(this.BilletsService.my_answer_marathon)
      );





      if((this.SettingsService.showHintAfterWrongAnswer  &&  answer == false) || (this.SettingsService.showHintAfterCorrectAnswer  &&  answer == true)){
        this.open_explanation = true
      }
      if(!this.SettingsService.showResultsOnlyAfterCompletion){
        if(this.SettingsService.autoNextQuestionAfterCorrectAnswer  && answer == true){
          this.nextQuiz()
        }

        if(this.SettingsService.autoNextQuestionAfterWrongAnswer && answer == false){
          this.nextQuiz()
        }
      }else{
        this.nextQuiz()
      }

    }

  }

  nextQuiz() {
    if (this.active_billet + 1 <= this.BilletsService.billets_question.length - 1) {
      this.openBillet(this.active_billet + 1)
      const element = this.billets.get(this.active_billet);
      if (this.scroll_billets.all_billets == false) {
        element?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',   // start | center | end | nearest
          block: 'nearest'
        });
      }
    }

  }

  count_error(){
    let count = 0;
    for(let i =0;  i <  this.BilletsService.billets_question.length; i++) {
      if(!this.BilletsService.billets_question[i].marathon?.status){
        count ++
      }
    }
    return count
  }
  count_success(){
    let count = 0;
    for(let i =0;  i <  this.BilletsService.billets_question.length; i++) {
      if(this.BilletsService.billets_question[i].marathon?.status){
        count ++
      }
    }
    return count
  }
}
